import { Box, Button, Card, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import UserList from "./UserList";
import PageHeaderLayout from "../../components/Layout/PageHeaderLayout";
import { PermissionGuard } from "../../components/PermissionGuard";
import { useNavigate } from "react-router-dom";
import { AddCircle, ArrowBack, Map } from "@mui/icons-material";
import IncompleteProfile from "./IncompleteProfile";

export default function User(){
    const menuDispatch = useDispatch();
    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'user'
        });
    }, []);
    const navigate = useNavigate();
    const [tabValue, setTabValue] = useState('0');
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    }
    return (
        <>
            <PageHeaderLayout headerTitle={'Manage Service Experts'}>
                <Box sx={{display:{xs:'none',sm:'flex',gap:'2%'}}}>

                     <Button variant='contained' onClick={() => navigate(`/admin/geo-expert`)}  sx={{width:'150px'}}
                     endIcon={<Map />}>
                    Geo Expert
                </Button>
                    <Button variant='contained' onClick={() => window.open(`/admin/experts-map`,'blank')} size='small' sx={{ py: '2px',width: {
                        xs: '120px', // full available width on mobile
                        //   sm: 'auto' // shrink on larger screens
                        } }} endIcon={<Map />}>
                    View Map
                </Button>
                    <PermissionGuard feature='service-expert' permission='canCreate'>
                        <Button variant='contained' onClick={() => navigate(`/admin/userProfile/0`)} size='small' sx={{ py: '2px',width:{xs:'100%',sm:'auto'} }} endIcon={<AddCircle />}>
                            Add
                        </Button>                    
                    </PermissionGuard>
                
                </Box>
                <Button variant='contained' onClick={() => navigate(-1)} size='small' endIcon={<ArrowBack />} sx={{ml:'.25% !important'}}>
                    Back
                </Button>
            </PageHeaderLayout>
            {/* when screen size is small show add and expert map button in other row */}
            <Card sx={{ minWidth: "100%", marginBottom: ".5%",display:{xs:'flex',sm:'none'} ,gap:'2%',alignItems:'center',justifyContent:'center'}}>
                <Button variant='contained' onClick={() => navigate(`/admin/geo-expert`)} size='small' sx={{ py: '2px',width:{xs:'100%',sm:'auto'} }} endIcon={<Map />}>
                    Geo Expert
                </Button>
                <Button variant='contained' onClick={() => window.open(`/admin/experts-map`,'blank')} size='small' sx={{ py: '2px',width:{xs:'100%',sm:'auto'} }} endIcon={<Map />}>
                    View Map
                </Button>
                {/* <Button variant='contained' onClick={() => navigate(-1)} size='small' endIcon={<ArrowBack />}>
                    Back
                </Button> */}
                <PermissionGuard feature='service-expert' permission='canCreate'>
                    <Button variant='contained' onClick={() => navigate(`/admin/userProfile/0`)} size='small' sx={{ml:{sm:'2%'}, py: '2px',width:{xs:'100%',sm:'auto'} }} endIcon={<AddCircle />}>
                        Add
                    </Button>                    
                </PermissionGuard>
            </Card>
            <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
                <Box sx={{ width: '100%' }}>
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    textColor="secondary"
                    indicatorColor="secondary"
                    aria-label="secondary tabs example"
                    sx={{ p: 0, minHeight: '40px' }}
                    variant="scrollable"
                    scrollButtons="auto"
                >

                    <Tab value="0" label="Completed Profile" sx={{ minHeight: '40px' , textTransform: 'capitalize' }} />
                    <Tab value="1" label="Incomplete Profile" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
                    {/* <Tab value="three" label="Item Three" /> */}
                </Tabs>
                </Box>
            </Card>
            {tabValue === '0' && <UserList />}
            {tabValue === '1' && <IncompleteProfile />}
            {/* <UserList /> */}
        </>
    )
}


// import { Box } from "@mui/material";
// import React, { useEffect } from "react";
// import { useDispatch } from "react-redux";
// import UserList from "./UserList";
// import MainContentLayout from "../../components/Layout/MainContentLayout";

// export default function User(){
//     const menuDispatch = useDispatch();
//     useEffect(() => {
//         menuDispatch({
//             type: 'menuSelect',
//             payload: 'user'
//         });
//     }
//     , []);
//     return (
//         <UserList />
//     )
// }